import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { TokenVO } from 'app/shared/models/core';
import { SessionViewModel } from 'app/shared/models/ei-models';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    private router = inject(Router);
    
    constructor() { }

    clearToken(): void {
        localStorage.removeItem('token');
        localStorage.removeItem('tokenData');
        localStorage.removeItem('usuarioId'); //TODO: Remover depois de configurar permissões 
        this.router.navigate(['/login']);
    }

    setToken(token: TokenVO): void {
        localStorage.setItem('token', token.token);
        localStorage.setItem('tokenData', JSON.stringify(token));
        localStorage.setItem('usuarioId', this.getTokenInfo().userId); //TODO: Remover depois de configurar permissões
    }

    getToken(): string {
        return localStorage.getItem('token')!;
    }

    isTokenValid(): boolean {

        const token = this.getToken();
        if (!this.getToken()) {
            return false;
        }

        try {
            const helper = new JwtHelperService();
            const isExpired = helper.isTokenExpired(token);
            return !isExpired;
        } catch (error) {
            return false;
        }
    }

    getTokenInfo() {
        try {
            const token = this.getToken();
            const helper = new JwtHelperService();
            const decodedToken = helper.decodeToken(token);
            return decodedToken;
        } catch (error) {
            return null;
        }

    }

    /** Retorna o escopo do JWT: "completo" para login normal ou "reativacao" para login de imobiliária suspensa. */
    getEscopo(): string | null {
        const info = this.getTokenInfo();
        return info?.escopo ?? info?.Escopo ?? null;
    }

    isReativacaoScope(): boolean {
        return this.getEscopo() === 'reativacao';
    }

    getUserInToken(): SessionViewModel {
        const token = this.getTokenInfo();
        if (token) {
            // Verifica diferentes possíveis nomes das claims (case-insensitive)
            const perfilId = token.perfilId || token.PerfilId || token.perfil_id || token.perfilid;
            const imobiliariaId = token.imobiliariaId || token.ImobiliariaId || token.imobiliaria_id;
            const planoId = token.planoId || token.PlanoId || token.plano_id;
            
            const currentUser = new SessionViewModel({
                userId: token.userId || token.UserId || token.user_id,
                name: token.given_name || token.name || token.Name,
                email: token.email || token.Email,
                renewPasswordFlag: token.renewPasswordFlag || token.RenewPasswordFlag,
                imobiliariaId: imobiliariaId && imobiliariaId != '' ? Number.parseInt(imobiliariaId) : null,
                planoId: planoId && planoId != '' ? Number.parseInt(planoId) : null,
                perfilId: perfilId && perfilId != '' ? Number.parseInt(perfilId) : null,
                termosAceitos: token.termosAceitos || token.TermosAceitos,
                onboardingConcluido: token.onboardingConcluido || token.OnboardingConcluido,
                urlFotoPerfil: token.urlFotoPerfil || token.UrlFotoPerfil
            });
            return currentUser;
        }
        return new SessionViewModel({});
    }
}
